export default __webpack_public_path__ + "static/media/header-container-purple.dc3600e7.png";